/* ============================================================
   The Squishy Box — homepage enhancements
   Lightweight, dependency-free, runs after DOM is ready.
   ============================================================ */
(function () {
  'use strict';

  /* Reveal sections gently as they enter the viewport */
  function initReveal() {
    var els = document.querySelectorAll('.sb-reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sb-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sb-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Show a friendly confirmation after a successful newsletter post.
     Shopify reloads the page with ?customer_posted=true on success. */
  function initNewsletter() {
    if (window.location.search.indexOf('customer_posted=true') === -1) return;
    document.querySelectorAll('.sb-news .sb-ok').forEach(function (ok) {
      if (ok.dataset.success) ok.textContent = ok.dataset.success;
    });
  }

  function init() {
    initReveal();
    initNewsletter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
